export const items = [
  {
    sys: { id: 0 },
    fields: {
      title: "google pixel - black",
      price: 10,
      company: "google",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,
      image: { fields: { file: { url: "img/product-0.png" } } }
    }
  },
  {
    sys: { id: 1 },

    fields: {
      title: "samsung s7 - white",
      price: 20,
      company: "samsung",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-1.png" } } }
    }
  },
  {
    sys: { id: 2 },

    fields: {
      title: "htc 10 - black",
      price: 30,
      company: "htc",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-2.png" } } }
    }
  },
  {
    sys: { id: 3 },

    fields: {
      title: "htc 10 - white",
      price: 15,
      company: "htc",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-3.png" } } }
    }
  },
  {
    sys: { id: 4 },

    fields: {
      title: "samsung s7 - black",
      price: 45,
      company: "google",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-4.png" } } }
    }
  },
  {
    sys: { id: 5 },

    fields: {
      title: "samsung galaxy A8 - black",
      price: 55,
      company: "samsung",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-5.png" } } }
    }
  },

  {
    sys: { id: 6 },

    fields: {
      title: "fuji X100s photo camera",
      price: 90,
      company: "fuji",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,

      image: { fields: { file: { url: "img/product-6.png" } } }
    }
  },
  {
    sys: { id: 7 },

    fields: {
      title: "canon Eos 30 photo camera",
      price: 120,
      company: "canon",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-7.png" } } }
    }
  },
  {
    sys: { id: 8 },

    fields: {
      title: "nikon D 3100 photo camera",
      price: 55,
      company: "nikon",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-8.png" } } }
    }
  },
  {
    sys: { id: 9 },

    fields: {
      title: "acer desktop computer",
      price: 35,
      company: "acer",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: true,

      image: { fields: { file: { url: "img/product-9.png" } } }
    }
  },
  {
    sys: { id: 10 },

    fields: {
      title: "hp desktop computer",
      price: 75,
      company: "hp",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,

      image: { fields: { file: { url: "img/product-10.png" } } }
    }
  },
  {
    sys: { id: 11 },

    fields: {
      title: "lenovo desktop computer",
      price: 110,
      company: "lenovo",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,
      image: { fields: { file: { url: "img/product-11.png" } } }
    }
  },
  {
    sys: { id: 12 },

    fields: {
      title: "dell desktop computer",
      price: 28,
      company: "dell",
      description:
        "Shaman hexagon fam activated charcoal literally cardigan. Pitchfork YOLO man bun hella. Trust fund vexillologist squid put a bird on it man braid, selvage pug. Schlitz kombucha chillwave pug shabby chic cornhole. Try-hard four loko listicle yuccie kitsch small batch narwhal celiac selfies distillery cloud bread farm-to-table art party leggings glossier.",
      featured: false,
      image: { fields: { file: { url: "img/product-12.png" } } }
    }
  }
];
